import React from "react";
import RetentionDashboard from "components/RetentionDashboard";
import { View } from "react-native-web";

export const RetentionDashboardSection = () => {
  return (
    <View style={{ flex: 1, width: "100%" }}>
      <RetentionDashboard />
    </View>
  );
};
